export const FETCH_ENCARGOS_REQUEST = "FETCH_ENCARGOS_REQUEST";
export const FETCH_ENCARGOS_SUCCESS = "FETCH_ENCARGOS_SUCCESS";
export const FETCH_ENCARGOS_FAILURE = "FETCH_ENCARGOS_FAILURE";
